import axios from 'axios';
import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const AlertService = {
  getAllAlertsAtViewAll: async (params, _instance) => {
    try {
      return (await apiClient.post('/getAllAlertsAtViewAll', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  getEditThresholdAlerts: async (params, _instance) => {
    try {
      return (await apiClient.post('/getAllEditThresholdValues', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  updateThresholdValues: async (params, _instance) => {
    try {
      return (await apiClient.post('/updateThresholdValues', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  markAsReviewed: async (params, _instance) => {
    try {
      return (await apiClient.post('/markAsReviewed', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  fetchAllAlertsType: async (params, _instance) => {
    try {
      return (await apiClient.post('/fetchAllAlertsType', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  bulkUpdateBasedOnAlertType: async (params, _instance) => {
    try {
      return (await apiClient.post('/bulkUpdateBasedOnAlertType', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  bulkEditThresholdFileUpload: async (params, _instance) => {
    try {
      return (await apiClient.post('/upload-excel', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },

  getAlertsInsightsChartData: async (params, _instance) => {
    try {
      return (await apiClient.post('/getAlertsInsightsChart', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },
  getAlertsInsightsChartDataTM: async (params, _instance) => {
    try {
      return (await apiClient.post('/getAlertsInsightsChartForTM', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      return null;
    }
  },

};

export default AlertService;
